import { useAppContext } from '../../appProvider/contextProvider'


const NativePrompt = () => {
    const {selectedWebsite} = useAppContext();
    return <div className="prompt-alert" data-alert="default">
        <div className="d-flex justify-content-between align-items-start mb-2 text-grey">
            <p className="text-dark">{selectedWebsite?.url} wants to</p>
            <button className="btn btn-neutral p-0 btn-close"><i className="icon icon-close"></i></button>
        </div> 
        <div className="description">
            <p><i className="icon icon-notification mr-2"></i>Show notifications</p>
        </div>
        <div className="d-flex justify-content-end align-items-end">
            <div className="d-flex text-right mt-2">
                <button className="btn btn-outline btn-allow">Allow</button>
                <button className="btn btn-outline btn-blocked ml-2">Block</button>                
            </div>
             
        </div>
        
    </div>  
}

export default NativePrompt;